module.exports = __webpack_public_path__ + "static/media/17.baa9a09d.jpg";